<div class="gfaq-page">

  <!-- Hero -->
  <div class="gfaq-hero">
    <div class="gfaq-hero__overlay"></div>
    <div class="gfaq-hero__content">
      <div class="gfaq-hero__eyebrow">Help Centre</div>
      <h1 class="gfaq-hero__title">Frequently Asked <span class="gfaq-hero__accent">Questions</span></h1>
      <ol class="gfaq-breadcrumb">
        <li><a [routerLink]="['/']"><i class="fa fa-home"></i></a></li>
        <li>FAQ</li>
        <li>General FAQ</li>
      </ol>
    </div>
  </div>

  <!-- Body -->
  <section class="gfaq-body">
    <div class="gfaq-container">

      <!-- Sidebar -->
      <aside class="gfaq-sidebar">
        <div class="gfaq-sidebar__header">Browse Topics</div>
        <ul class="gfaq-sidebar__list">
          <li><a [routerLink]="['/11plus-help-club/faq/general-faq']" class="gfaq-sidebar__link gfaq-sidebar__link--active"><span class="gfaq-sidebar__dot"></span>General FAQ</a></li>
          <li><a [routerLink]="['/11plus-help-club/faq/faq-for-parent-teacher']" class="gfaq-sidebar__link"><span class="gfaq-sidebar__dot"></span>FAQ for Parent / Teacher</a></li>
          <li><a [routerLink]="['/11plus-help-club/faq/faq-for-student']" class="gfaq-sidebar__link"><span class="gfaq-sidebar__dot"></span>FAQ for Student</a></li>
          <li><a [routerLink]="['/11plus-help-club/faq/faq-for-volunteers']" class="gfaq-sidebar__link"><span class="gfaq-sidebar__dot"></span>FAQ for Volunteers</a></li>
          <li><a [routerLink]="['/11plus-help-club/faq/faq-for-community']" class="gfaq-sidebar__link"><span class="gfaq-sidebar__dot"></span>FAQ for Community</a></li>
        </ul>

        <div class="gfaq-cta-card">
          <div class="gfaq-cta-card__icon"><i class="fa fa-phone"></i></div>
          <h3 class="gfaq-cta-card__title">Still have questions?</h3>
          <p class="gfaq-cta-card__text">Our team is here to help you find the right support for your child.</p>
          <a [routerLink]="['/contact-us']" class="gfaq-cta-card__btn">Request a Call Back</a>
        </div>
      </aside>

      <!-- Content -->
      <div class="gfaq-content">
        <div class="gfaq-content__top">
          <h2 class="gfaq-content__title">General FAQ</h2>
          <div class="gfaq-content__rule"></div>
        </div>

        <div class="gfaq-accordion">

          <!-- Q1 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq1" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">I have booked a SEHYOG test/session but did not receive the confirmation yet?</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq1" class="gfaq-accordion__body content collapse in">
              <div class="gfaq-accordion__answer">
                <p>Dear Parent, Confirmation email is automatically fired as soon as you book the test – please check your registered email inbox or junk folder.</p>
                <p><strong>Classroom Exams:</strong></p>
                <p>User could download the Hall Ticket online from SEHYOG account: 1. Login to your SEHYOG account – SEHYOG.co.uk 2. Click on the Actions (little eye) button available far right on the confirmed booking row/line 3. Click 'Download' or 'Email' Button.</p>
                <ol>
                  <li>Goto <a href="https://sehyog.co.uk" target="_blank">sehyog.co.uk</a></li>
                  <li>Goto MY STUDENT listing</li>
                  <li>Click on ONLINE EXAM under actions column</li>
                  <li>A new window will open – click TEST to do the test and click SCORE to review the score &amp; test results.</li>
                </ol>
              </div>
            </div>
          </div>

          <!-- Q2 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq2" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">How to book a SEHYOG session?</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq2" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <p>Its three step process : (1) goto sehyog.co.uk and sign up also create an account (2) An email will be sent to verify the account, verify and login to your SEHYOG account (3) Add Student and goto session listing page to book a session you are see listing on the landing page (or click on SEHYOG logo – top left), scroll down, click on the available session and follow instructions.</p>
              </div>
            </div>
          </div>

          <!-- Q3 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq3" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">Can Year 4 students sit in SEHYOG 11+ tests?</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq3" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <p>Yes, however parents must not expect very high yield (60/70 %) from a year 4 student, anything around 30/40 % performance should be OK because their mind is one year younger and not all topics covered for them in full detail like a year 5 student. First, get yourself familiarised with the difficulty level of questions, paper formats, experience like for the test environment, case studies, learn from senior parents and children, better planning ahead when student starts year 5, learn 11+ tips &amp; tricks etc. Cons: Parents may get panicked with the test results because performance of a Year 4 student will of course not be same as Year 5 reason being that they are not yet exposed to the same standard of questions.</p>
              </div>
            </div>
          </div>

          <!-- Q4 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq4" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">How to edit child/student records?</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq4" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <p>Login to SEHYOG account then follow steps – 1. Goto 'My Account' – user will be redirected to 'My account' page when login first time. 2. Click on 'My students' menu 3. Click on 'Student Listing' 4. Click on edit button 5. Update records 6. Save</p>
              </div>
            </div>
          </div>

          <!-- Q5 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq5" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">COVID-19 Updates</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq5" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <p>It is of paramount importance that SEHYOG 11plusHelpClub remains a safe place for students, parents and volunteers. SEHYOG volunteers recognise that there are risks associated with the reopening of the club, while coronavirus is still present in our communities. The aim of this risk assessment is to ensure that all the obvious significant risks related to Coronavirus have been considered. Please refer <a href="https://www.sehyog.co.uk/covid-guidelines" target="_blank">COVID-19 safeguarding guidelines</a> for detailed information.</p>
              </div>
            </div>
          </div>

          <!-- Q6 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq6" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">Transport for Grammar Schools</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq6" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <p><a href="https://www.sehyog.co.uk/transport-for-grammar-schools" target="_blank">Transport for Grammar Schools</a></p>
              </div>
            </div>
          </div>

          <!-- Q7 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq7" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">11plus preparation books</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq7" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <p><a href="https://www.sehyog.co.uk/11plus-prep-books" target="_blank">11plus prep books</a></p>
              </div>
            </div>
          </div>

          <!-- Q8 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq8" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">Grammar schools cut off, min score offered a place in past and school wise score history</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq8" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <p><a href="https://www.sehyog.co.uk/grammar-schools-cutoff" target="_blank">Grammar schools cut off, min score offered a place and school wise score history</a></p>
              </div>
            </div>
          </div>

          <!-- Q9 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq9" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">New joiners guide</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq9" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <p><a href="https://www.sehyog.co.uk/new-joiners-guide" target="_blank">New joiners guide</a></p>
              </div>
            </div>
          </div>

          <!-- Q10 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq10" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">How to check online result?</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq10" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <p>Go to ONLINE EXAM platform → Go to 'Score'</p>
                <ol>
                  <li><strong>'Response'</strong> to view student &amp; teacher responses – teacher responses are in 'Remark' column.</li>
                  <li><strong>'Analysis'</strong> to view the detailed Result Report – this is a downloadable pdf containing:
                    <ul>
                      <li>Total students count</li>
                      <li>Candidate total score</li>
                      <li>Section wise score</li>
                      <li>Overall analysis</li>
                      <li>Section wise analysis</li>
                      <li>Top 5 Ranks</li>
                      <li>Break-down of Test Score</li>
                      <li>Comparison of Section-wise Count</li>
                      <li>Comparison of Score based on Difficulty (Based on Candidate Response Stats)</li>
                      <li>Section wise comparison etc.</li>
                    </ul>
                  </li>
                  <li><strong>'Review'</strong> to review full paper and candidate's response question wise.</li>
                </ol>
              </div>
            </div>
          </div>

          <!-- Q11 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq11" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">How to access Sehyog ONLINE EXAM platform?</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq11" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <ol>
                  <li>Goto <a href="https://sehyog.co.uk" target="_blank">sehyog.co.uk</a> and login using Sehyog account.</li>
                  <li>On Sehyog Dashboard, Goto MY STUDENT listing.</li>
                  <li>Click on 'ONLINE EXAM' under actions column vs. respective student row.</li>
                  <li>A new page will open – click on TEST button there to access the test and click SCORE to review the score/results.</li>
                </ol>
              </div>
            </div>
          </div>

          <!-- Q12 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq12" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">How can I join Sehyog Telegram group chat for live support?</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq12" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <p>Join Telegram group chat for live support using below link – <a href="https://t.me/joinchat/B0bMiMuZhaSums4" target="_blank">https://t.me/joinchat/B0bMiMuZhaSums4</a></p>
              </div>
            </div>
          </div>

          <!-- Q13 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq13" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">How to cancel Sehyog classroom session?</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq13" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <ol>
                  <li>Login to your Sehyog account on sehyog.co.uk</li>
                  <li>goto "My Classroom Session" – your confirmed sessions list will appear on right side.</li>
                  <li>Click "Action" button e.g. a little eye</li>
                  <li>On the next page, use CANCEL button to cancel the session</li>
                  <li>Refund will take 3-5 work days</li>
                  <li>PayPal will charge a small fee for the cancellation (in pence)</li>
                </ol>
              </div>
            </div>
          </div>

          <!-- Q14 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq14" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">How to attempt Creative Writing Test online?</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq14" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <ul>
                  <li>Goto sehyog.co.uk</li>
                  <li>Goto 'MY STUDENT' listing</li>
                  <li>Click on 'ONLINE EXAM' under actions column</li>
                  <li>A new window will open – click TEST to access the test.</li>
                  <li>Open CW Test and note down Creative Writing the topics</li>
                  <li>Close the browser (do not submit the test)</li>
                  <li>Ask student to write the topics on a paper in defined time 20 minutes for 2 topics</li>
                  <li>Once done, scan the document as pdf.</li>
                  <li>Open the Test again using instruction 1-5 and click on upload button to upload this pdf and submit.</li>
                  <li>Now, submit the test.</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Q15 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq15" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">How to access eLearning platform or Online Exam platform?</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq15" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <ol>
                  <li>Login to sehyog.co.uk using your credentials</li>
                  <li>Go to 'My Students' and click on 'Student Listing' link or</li>
                  <li>Alternatively, use the big blue box on your dashboard available on the right side pane after login</li>
                  <li>Use e-learning button to navigate to the e-learning platform.</li>
                  <li>Quick video step-by-step – <a href="https://www.sehyog.co.uk/how-to-access-elearning" target="_blank">How to access e-learning dashboard!</a></li>
                </ol>
              </div>
            </div>
          </div>

          <!-- Q16 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq16" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">How to access GCSE Mocks online?</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq16" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <p>How to access online exam (GCSE?)</p>
                <p><strong>Instructions:</strong></p>
                <ol>
                  <li>Log in to sehyog.co.uk using your credentials and navigate to the 'My Students' dashboard.</li>
                  <li>Click the 'eLearning' link to access the eLearning platform.</li>
                  <li>On the eLearning Dashboard, go to the 'Test' page, where the AQA papers are listed.</li>
                  <li>Use the downward arrow button to download the paper in PDF and close the browser.</li>
                  <li>Ask the student to attempt the paper at home under exam conditions within the allocated time (please ensure proper invigilation).</li>
                  <li>Once completed, scan the papers into a PDF file and use the upward arrow button to upload them for the teacher's review. Do not submit.</li>
                  <li>Teachers will review, mark, and provide comments for your reference.</li>
                  <li>Marked papers will either be emailed back to you or re-uploaded in the platform.</li>
                  <li>Need help? Contact us on provided lines</li>
                </ol>
                <p><strong>Contact Us:</strong></p>
                <p>
                  Hotline: +44 3301339827<br>
                  WhatsApp: +44 7464772331<br>
                  Email: support@sehyog.co.uk<br>
                  Website: www.sehyog.co.uk
                </p>
                <p>
                  Best Wishes<br>
                  Team SEHYOG, UK<br>
                  www.sehyog.co.uk/gcse-test
                </p>
              </div>
            </div>
          </div>

          <!-- Q17 -->
          <div class="gfaq-accordion__item">
            <a class="gfaq-accordion__trigger cursor" href="#gfaq17" data-toggle="collapse">
              <span class="gfaq-accordion__q">Q</span>
              <span class="gfaq-accordion__question">How to Book an 11+ Mock Test</span>
              <i class="fa fa-angle-down gfaq-accordion__icon"></i>
            </a>
            <div id="gfaq17" class="gfaq-accordion__body content collapse">
              <div class="gfaq-accordion__answer">
                <ul>
                  <li><strong>Sign Up:</strong> Register using your Google email at sehyog.co.uk/signup</li>
                  <li><strong>Add Student:</strong> Log in and go to My Students to add your child.</li>
                  <li><strong>Go to 11+ Mock Test Page:</strong> From the Mock Test menu, select 11+ Mock Test.</li>
                  <li><strong>View Calendar:</strong> Use the Face-to-face or Online toggle to view the test calendar.</li>
                  <li><strong>Choose Center &amp; Month:</strong> Select your preferred center and month to see available tests.</li>
                  <li><strong>Select Test:</strong> Find your test type (e.g., CGL, GL, FCE1) and click Select Center.</li>
                  <li><strong>Book Slot:</strong> Click Book a Slot, choose your student, and add to basket.</li>
                  <li><strong>Payment:</strong> Go to your basket and pay via PayPal or card.</li>
                  <li><strong>Get Hall Ticket:</strong> A confirmation email will include the PDF Hall Ticket – print just bring it on exam day.</li>
                  <li><strong>Download Anytime:</strong> Or download it from My Account → My Upcoming Classroom Session → View Details.</li>
                </ul>
              </div>
            </div>
          </div>

        </div><!-- /accordion -->
      </div><!-- /content -->

    </div><!-- /container -->
  </section>

</div>